import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from './pages/homepage/HomePage';
import Navbar from './pages/navbar/Navbar';
import ServicesPage from './pages/services/ServicesPage';
import AiSolutionsPage from './pages/ai-solutions/AiSolutionsPage';
import MarketingGrowthPage from './pages/marketing-growth/MarketingGrowthPage';
import ResearchInsightsPage from './pages/research-insights/ResearchInsightsPage';
import InnovationStudioPage from './pages/innovation-studio/InnovationStudioPage';
import IndustriesPage from './pages/industries/IndustriesPage';
import ContactPage from './pages/contact/ContactPage';
import AboutPage from './pages/about/AboutPage';


function App() {
  return (
    <Router>
      <Navbar />
      <Routes>

        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/ai-solutions" element={<AiSolutionsPage/>} />
        <Route path="/marketing-growth-advisory" element={<MarketingGrowthPage />} />
        <Route path="/research-insights" element={<ResearchInsightsPage />} />
        <Route path="/innovation-studio" element={<InnovationStudioPage />} />
        <Route path="/industries" element={<IndustriesPage />} />
        <Route path="/contact" element={<ContactPage />} />

      </Routes>
    </Router>
  );
}

export default App;